import {useForm} from 'antd/es/form/Form';
import React, {ReactElement} from 'react';

import {Search} from 'components/@common/inputs/search';
import {ActionBar} from 'components/@common/widgets/action-bar';
import {AIS_ROUTES} from 'components/ais/ais.constants';
import {SimpleActionButton} from 'components/form/components';
import {ModalOpenerComponent} from 'components/modal-opener-component';
import {useUserRoleFunctions} from 'shared/hooks/use-user-role-functions';
import {EUserRoleFunction} from 'store/slices/user-slice/user-slice-role-functions';

import {IActionPanel} from '../../model/types';

export const ActionPanel = <T,>({config, children, customComponents}: IActionPanel<T>): ReactElement => {
    const {
        selectedRowKeys,
        handleDeleteRows,
        handleFinish,
        title,
        isCreateDisabled,
        isDeleteDisabled,
        // параметры для поиска
        isSearchDisabled = true,
        setSearch,
    } = config;

    const {hasUserRoleFunction} = useUserRoleFunctions({sections: [AIS_ROUTES.ORGANIZATION_STRUCTURE_V5]});

    const isCreateAllowed = hasUserRoleFunction(EUserRoleFunction.CREATE) && !isCreateDisabled;

    const isDeleteAllowed = hasUserRoleFunction(EUserRoleFunction.DELETE) && !isDeleteDisabled;

    const [form] = useForm();

    return (
        <ActionBar>
            <section className="d-flex justify-content-between w-100">
                <div className="d-flex gap-2">
                    {isCreateAllowed && (
                        <ModalOpenerComponent
                            component={
                                <SimpleActionButton
                                    type="primary"
                                    icon="PlusCircleOutlined"
                                    title="Создать"
                                    onClick={() => {}}
                                />
                            }
                            controlsStyle={{marginTop: '20px'}}
                            modalProps={{title}}
                            controlLabels={{save: 'Сохранить'}}
                            handleSave={async (setIsModalOpen) => {
                                try {
                                    await form.validateFields();
                                    form.submit();
                                    setIsModalOpen(false);
                                } catch (e) {
                                    console.error(e);
                                }
                            }}
                            shouldConfirm={() => form.isFieldsTouched()}
                            handleCancel={(setIsModalOpen) => {
                                form.resetFields();
                                setIsModalOpen(false);
                            }}
                            afterModalClose={() => {
                                form.resetFields();
                            }}
                        >
                            {children && children(form, handleFinish)}
                        </ModalOpenerComponent>
                    )}
                    {isDeleteAllowed && (
                        <ModalOpenerComponent
                            component={
                                <SimpleActionButton
                                    disabled={selectedRowKeys?.length === 0}
                                    type="primary"
                                    className="button-critic"
                                    icon="TrashXOutlined"
                                    title="Удалить выбранное"
                                />
                            }
                            controlsStyle={{marginTop: '20px'}}
                            modalProps={{title: 'Удаление'}}
                            controlLabels={{save: 'Удалить'}}
                            handleSave={(setIsModalOpen) => {
                                if (handleDeleteRows && selectedRowKeys) handleDeleteRows(selectedRowKeys);
                                setIsModalOpen(false);
                            }}
                        >
                            Вы уверены, что хотите удалить документ/запись?
                        </ModalOpenerComponent>
                    )}
                    {customComponents}
                </div>
                {
                    !isSearchDisabled && (
                        <div className="d-flex">
                            <Search
                                setSearch={setSearch}
                            />
                        </div>
                    )
                }
            </section>
        </ActionBar>
    );
};
